import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nationalMemberField", "prefixSelect", "nationalMemberInput", "tenantSelect"]

  static values = { requireTenant: Boolean }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasPrefixSelectTarget || !this.hasNationalMemberFieldTarget || !this.hasNationalMemberInputTarget) return

    const affiliated = !this.requireTenantValue || (this.hasTenantSelectTarget && Array.from(this.tenantSelectTarget.selectedOptions).some(option => option.dataset.affiliated === "true"))
    const showNationalMemberField = affiliated && this.prefixSelectTarget.value === "+61"

    this.nationalMemberFieldTarget.classList.toggle("hidden", !showNationalMemberField)

    if (!showNationalMemberField) {
      this.nationalMemberInputTarget.value = ""
    }
  }
}
